// react
import React, { Suspense } from "react";

// components
import Spinner from "../../components/Spinner/ComponentLoader";

// load in the goal tree
const AdminEmployeesPage = React.lazy(() => import("./AdminEmployees"));

const AdminEmployeesLazyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<AdminEmployeesPage />
	</Suspense>
);

export default AdminEmployeesLazyLoader;
